export const HIDEABLE_ELEMENTS = [
  'mono-hidden',
  'mono-hidden-visually',
  'mono-alert',
  'mono-global-alert',
  'mono-stack',
];
